import { defineMessages } from 'react-intl';

export default defineMessages({
  ESTIMATED_READING_TIME: {
    defaultMessage: 'Temps de lecture estimé :',
  },

  FORMATTED_TIME: {
    defaultMessage:
      "{hours, plural, =0 {{minutes, plural, =0 {moins d'une minute} other {# min}}} other {{hours}h{formattedMinutes}}}",
  },
} as const);
